import { render, staticRenderFns } from "./IconXCircleSolid.vue?vue&type=template&id=f90e7738"
import script from "./IconXCircleSolid.vue?vue&type=script&lang=js"
export * from "./IconXCircleSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports